export class Constants {
  public static INPUT_TYPE = {
    TEXT: "text",
    NUMBER: "number",
    PASSWORD: "password",
    DROPDOWN: "dropdown",
    LEVEL2_DROPDOWN: "leveldropdown",
    TEXTAREA: "textarea",
    FILE: "file",
    DATE_TIME: 'datetime-local',
    CALENDAR: "date",
    RADIO: "radio",
    CHECKBOX: "checkbox",
    TIME: "time",
    MAXDATE: "12/31/2099",
  };
  // Text-vs-Variable toggle used by location/step-value overlays (e.g. valueType).
  public static DATA_TYPE = {
    TEXT: "text",
    VARIABLE: "variable",
  } as const;
  public static DROPDOWN_DATATYPES = {
    IMAGE: "image",
    SVG: "svg",
    SYMBOL: "symbol",
    CLASS: "class",
  };
  public static LocalStorageVariables = {
    UserID: "UserID",
    UTMData: "UTMMetaData",
    IsUserVerified: "isUserVerified",
    UserGUID: "UserGUID",
  };
  public static SessionStoraegVariable = {
    ApplicationGUID: "applicationGUID",
    ReleaseID: "releaseID",
    SubscriptionDaysLeft: "subscriptionDaysLeft",
  };
  public static EDITABLE_ACTIONS = {
    ASSERT_EXISTS_EXACT_MATCH: "Test component is present",
    ASSERT_NOT_EXISTS_EXACT_MATCH: "Test component is not present",
    ASSERT_ENABLED: "Test component is enabled",
    ASSERT_NOT_ENABLED: "Test component is disabled",
    ASSERT_CHECKED: "Test component is checked",
    ASSERT_UNCHECKED: "Test component is unchecked",
    COMPONENT_CONTAINS: "Test component has content",
    ASSERT_TEST_DATA_VARIABLE: "Should be equal variable",
    ASSERT_TEST_CASE_VARIABLE: "Should be equal test case variable",
    ASSERT_API_STEP_VARIABLE: "Should be equal api variable",
    ASSERT_EQUALS_EXACT_MATCH: "Should be equal",
    ASSERT_NOT_EQUALS_EXACT_MATCH: "Should not be equal",
    ASSERT_EQUALS_SIMILAR: "Should contain",
    ASSERT_NOT_EQUALS_SIMILAR: "Should not contain",
    ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH: "Should be equal data variable",
    ASSERT_TEST_DATA_VARIABLE_NOT_EXACT_MATCH:
      "Should not be equal data variable",
    ASSERT_TEST_CASE_VARIABLE_NOT_EQUALS_EXACT_MATCH:
      "Should not be equal to test case variable",
    ASSERT_API_STEP_VARIABLE_NOT_EQUALS_EXACT_MATCH:
      "Should not be equal to api variable",
    ASSERT_TEST_DATA_VARIABLE_EQUALS_SIMILAR: "Should contain data variable",
    ASSERT_TEST_CASE_VARIABLE_EQUALS_SIMILAR:
      "Should contain test case variable",
    ASSERT_API_STEP_VARIABLE_EQUALS_SIMILAR: "Should contain api variable",
    ASSERT_TEST_DATA_VARIABLE_NOT_EQUALS_SIMILAR:
      "Should not contain data variable",
    ASSERT_TEST_CASE_VARIABLE_NOT_EQUALS_SIMILAR:
      "Should not contain test case variable",
    ASSERT_API_STEP_VARIABLE_NOT_EQUALS_SIMILAR:
      "Should not contain api variable",
    ASSERT_TEST_CASE_VARIABLE_NOT_EXACT_MATCH:
      "Should not be equal test case variable",
    ASSERT_API_STEP_VARIABLE_NOT_EXACT_MATCH: "Should not equal api variable",
    ASSERT_NUMERIC_EQUAL: "Test component is equal to",
    ASSERT_NUMERIC_GREATER: "Test component is greater than",
    ASSERT_NUMERIC_GREATER_EQUAL: "Test component is greater than or equal to",
    ASSERT_NUMERIC_LESSER: "Test component is less than",
    ASSERT_NUMERIC_LESSER_EQUAL: "Test component is less than or equal to",
    ASSERT_NUMERIC_INBETWEEN: "Test component is in-between",
    ASSERT_NUMERIC_EQUAL_TEST_DATA_VARIABLE:
      "Numeric Test component is equal to data variable",
    ASSERT_NUMERIC_GREATER_TEST_DATA_VARIABLE:
      "Numeric Test component is greater than data variable",
    ASSERT_NUMERIC_GREATER_EQUAL_TEST_DATA_VARIABLE:
      "Numeric Test component is greater than or equal to data variable",
    ASSERT_NUMERIC_LESSER_TEST_DATA_VARIABLE:
      "Numeric Test component is less than data variable",
    ASSERT_NUMERIC_LESSER_EQUAL_TEST_DATA_VARIABLE:
      "Numeric Test component is less than or equal to data variable",
    ASSERT_NUMERIC_INBETWEEN_TEST_DATA_VARIABLE:
      "Numeric Test component is in-between data variable",
    ASSERT_NUMERIC_EQUAL_ARITHMETIC_VARIABLE:
      "Numeric Test component is equal to arithmetic variable",
    ASSERT_NUMERIC_GREATER_ARITHMETIC_VARIABLE:
      "Numeric Test component is greater than arithmetic variable",
    ASSERT_NUMERIC_GREATER_EQUAL_ARITHMETIC_VARIABLE:
      "Numeric Test component is greater than or equal to arithmetic variable",
    ASSERT_NUMERIC_LESSER_ARITHMETIC_VARIABLE:
      "Numeric Test component is less than arithmetic variable",
    ASSERT_NUMERIC_LESSER_EQUAL_ARITHMETIC_VARIABLE:
      "Numeric Test component is less than or equal to arithmetic variable",
    ASSERT_NUMERIC_INBETWEEN_ARITHMETIC_VARIABLE:
      "Numeric Test component is in-between arithmetic variable",
    ASSERT_VISUAL_MATCH: 'Component is visually present',
    ASSERT_ARITHMETIC_VARIABLE: "Should be equal arithmetic variable",
    ASSERT_ARITHMETIC_VARIABLE_NOT_EXACT_MATCH: "Should not be equal arithmetic variable",
    ASSERT_ARITHMETIC_VARIABLE_EQUALS_SIMILAR: "Should contain arithmetic variable",
    ASSERT_ARITHMETIC_VARIABLE_NOT_EQUALS_SIMILAR: "Should not contain arithmetic variable",

    // Values for New Structure
     TEXT_ASSERT: 'Text',
     NUMERIC_ASSERT: 'Numeric',
     TEXT_SUB_ASSERT: 'has content',
     COMPONENT_ASSERT: 'Component',
  };

  public static ACTION_STATE_ICON = {
    'PASS': 'passCircleIcon',
    'FAIL': 'failCircleIcon',
    'WARNING': 'alertCircleIcon'
  };

  public static CARDED_STEPS: Array<string> = [
    'TIME_DELAY',
    'APP_LAUNCH',
    'MockGPSLocation',
    'APP_SWITCHER',
    'OVERRIDE_TEST_DATA_VARIABLE',
    'OVERRIDE_TEST_CASE_VARIABLE',
    'OVERRIDE_ARITHMETIC_VARIABLE',
    'OVERRIDE_API_VARIABLE',
    'API_STEP',
    'VARIABLE_COMPARISON',
    'DEEP_LINK',
    'DEEP_LINK_WITH_VARIABLE',
    'ARITHMETIC_STEP'
  ];

  public static NON_MANUAL_OVERRIDE_ACTIONS = [ 
    'APP_LAUNCH',
    'APP_CLOSED',
    'TOGGLE_WIFI',
    'ENTER_KEY',
    'BACK_KEY',
    'SWIPE_TILL_ELEMENT',
    'RESET_APP',
    'HOME_KEY',
    'TIME_DELAY',
    'MockGPSLocation',
    'DISABLED_STEP',
    'SWITCH_NETWORK',
    'ROTATE_DEVICE',
    'TEMPLATE',
    'APP_SWITCHER',
    'APP_CRASH_REBOOT',
    'API_STEP',
    'SWIPE',
    'CLEAR_TEXT',
    'ADD_TEST_DATA',
    'SET_TEXT',
    'SAVE_API_STEP_VARIABLE',
    'SET_API_STEP_VARIABLE',
    'OVERRIDE_TEST_DATA_VARIABLE',
    'OVERRIDE_TEST_CASE_VARIABLE',
    'OVERRIDE_ARITHMETIC_VARIABLE',
    'OVERRIDE_API_VARIABLE',
    'SET_TEST_CASE_VARIABLE',
    'SET_ARITHMETIC_VARIABLE',
    'SEND_ASSERT_API_STEP_VARIABLE',
    'UNEXPECTED_SCREEN',
    'LOADING_WAIT',
    'DEEP_LINK',
    'DEEP_LINK_WITH_VARIABLE',
    'PASTE_FROM_CLIPBOARD',
    'DOUBLE_FINGER_LONG_PRESS',
    'OPEN_NOTIFICATIONS',
    'CLOSE_NOTIFICATIONS'
  ]

  public static NONIMPLICITACTIONS = [
    "APP_LAUNCH",
    "BACK_KEY",
    "APP_SWITCHER",
    "HOME_KEY",
    "CLEAR_TEXT",
    "ENTER_KEY",
    "TIME_DELAY",
    "TOGGLE_WIFI",
    "ROTATE_DEVICE",
    "SET_TEXT",
    "MockGPSLocation",
    "ADD_TEST_DATA",
    "SET_TEST_CASE_VARIABLE",
    'SET_ARITHMETIC_VARIABLE',
    "API_STEP",
    "SET_API_STEP_VARIABLE",
    "RESET_APP",
    "APP_CRASH_REBOOT",
    "OVERRIDE_TEST_DATA_VARIABLE",
    "OVERRIDE_TEST_CASE_VARIABLE",
    "OVERRIDE_ARITHMETIC_VARIABLE",
    "OVERRIDE_API_VARIABLE",
    "DEEP_LINK",
    'DEEP_LINK_WITH_VARIABLE',
    'PASTE_FROM_CLIPBOARD',
    'DOUBLE_FINGER_LONG_PRESS',
    'OPEN_NOTIFICATIONS',
    'CLOSE_NOTIFICATIONS'
  ];
  
  public static ALL_ACTIONS = {
    NO_OP: "NO_OP",
    APP_LAUNCH: "APP_LAUNCH",
    API_STEP: 'API_STEP',
    BACK_KEY: "BACK_KEY",
    MOCKGPSLOCATION: 'MockGPSLocation',
    "SWIPE(3)": "SWIPE(3)",
    SWIPE: "SWIPE",
    SWIPE_TILL_ELEMENT: "SWIPE_TILL_ELEMENT",
    OVERRIDE_TEST_DATA_VARIABLE: 'OVERRIDE_TEST_DATA_VARIABLE',
    OVERRIDE_TEST_CASE_VARIABLE: 'OVERRIDE_TEST_CASE_VARIABLE',
    OVERRIDE_ARITHMETIC_VARIABLE: 'OVERRIDE_ARITHMETIC_VARIABLE',
    OVERRIDE_API_VARIABLE: 'OVERRIDE_API_VARIABLE',
    VARIABLE_COMPARISON: 'VARIABLE_COMPARISON',
    SEEK_BAR: "SEEK_BAR",
    CLICK: "CLICK",
    LONG_CLICK: "LONG_CLICK",
    SET_TEXT: "SET_TEXT",
    SET_API_STEP_VARIABLE: "SET_API_STEP_VARIABLE",
    ADD_TEST_DATA: "ADD_TEST_DATA",
    SET_TEST_CASE_VARIABLE: "SET_TEST_CASE_VARIABLE",
    SET_ARITHMETIC_VARIABLE: 'SET_ARITHMETIC_VARIABLE',
    SAVE_TEST_CASE_VARIABLE: "SAVE_TEST_CASE_VARIABLE",
    UNEXPECTED_SCREEN: "UNEXPECTED_SCREEN",
    APP_CLOSED: "APP_CLOSED",
    LOADING_WAIT: "LOADING_WAIT",
    ENTER_KEY: "ENTER_KEY",
    RESET_APP: "RESET_APP",
    PICK_DATE: "PICK_DATE",
    EXPECTED: "EXPECTED",
    GOOGLEPERMISSIONS: "GOOGLEPERMISSIONS",
    HOME_KEY: "HOME_KEY",
    ASSERTION: "ASSERTION",
    DRAG_AND_DROP: "DRAG_AND_DROP",
    ASSERT: 'ASSERT',
    ASSERT_EXISTS_SIMILAR: "ASSERT_EXISTS_SIMILAR",
    ASSERT_EXISTS_EXACT_MATCH: "Test component is present",
    ASSERT_NOT_EXISTS_EXACT_MATCH: "Test component is not present",
    ASSERT_ENABLED: "Test component is enabled",
    ASSERT_NOT_ENABLED: "Test component is disabled",
    ASSERT_CHECKED: "Test component is checked",
    ASSERT_UNCHECKED: "Test component is unchecked",
    ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH: "Should be equal variable",
    ASSERT_EQUALS_EXACT_MATCH: "Should be equal",
    ASSERT_NOT_EQUALS_EXACT_MATCH: "Should not be equal",
    ASSERT_EQUALS_SIMILAR: "Should contain",
    ASSERT_NOT_EQUALS_SIMILAR: "Should not contain",
    ASSERT_ARITHMETIC_VARIABLE: "Should be equal arithmetic variable",
    ASSERT_ARITHMETIC_VARIABLE_NOT_EXACT_MATCH: "Should not be equal arithmetic variable",
    ASSERT_ARITHMETIC_VARIABLE_EQUALS_SIMILAR: "Should contain arithmetic variable",
    ASSERT_ARITHMETIC_VARIABLE_NOT_EQUALS_SIMILAR: "Should not contain arithmetic variable",
    ASSERT_NUMERIC_EQUAL_ARITHMETIC_VARIABLE: "Numeric Test component is equal to arithmetic variable",
    ASSERT_NUMERIC_GREATER_ARITHMETIC_VARIABLE: "Numeric Test component is greater than arithmetic variable",
    ASSERT_NUMERIC_GREATER_EQUAL_ARITHMETIC_VARIABLE: "Numeric Test component is greater than or equal to arithmetic variable",
    ASSERT_NUMERIC_LESSER_ARITHMETIC_VARIABLE: "Numeric Test component is less than arithmetic variable",
    ASSERT_NUMERIC_LESSER_EQUAL_ARITHMETIC_VARIABLE: "Numeric Test component is less than or equal to arithmetic variable",
    ASSERT_NUMERIC_INBETWEEN_ARITHMETIC_VARIABLE: "Numeric Test component is in-between arithmetic variable",
    CLEAR_TEXT: "CLEAR_TEXT",
    TOGGLE_WIFI: "TOGGLE_WIFI",
    TIME_DELAY: "TIME_DELAY",
    TEMPLATE: "TEMPLATE",
    ZOOM_IN: "ZOOM_IN",
    ZOOM_OUT: "ZOOM_OUT",
    ROTATE_DEVICE: 'ROTATE_DEVICE',
    APP_SWITCHER: 'APP_SWITCHER',
    DEEP_LINK: 'DEEP_LINK',
    DEEP_LINK_WITH_VARIABLE: 'DEEP_LINK_WITH_VARIABLE',
    ARITHMETIC_STEP: 'ARITHMETIC_STEP',
    UI_VALIDATION: 'UI_VALIDATION_STEP',
    PASTE_FROM_CLIPBOARD: 'PASTE_FROM_CLIPBOARD',
    DOUBLE_FINGER_LONG_PRESS: 'DOUBLE_FINGER_LONG_PRESS',
    OPEN_NOTIFICATIONS: 'OPEN_NOTIFICATIONS',
    CLOSE_NOTIFICATIONS: 'CLOSE_NOTIFICATIONS'

  };

  public static NON_DIFFERENCES_ACTIONS = {
    APP_LAUNCH: 'Application launched',
    APP_CLOSED: 'Application closed',
    TOGGLE_WIFI: 'Toggle wifi:',
    ENTER_KEY: 'Enter button pressed',
    BACK_KEY: 'Back button pressed',
    RESET_APP: 'Reset application:',
    HOME_KEY: 'Home button pressed',
    TIME_DELAY: 'Time Delay of',
    MockGPSLocation: 'GPS location set',
    DISABLED_STEP: 'Step is disabled',
    SWITCH_NETWORK: 'Switch Network',
    ROTATE_DEVICE: 'Device orientation changed to',
    TEMPLATE: '',
    APP_SWITCHER: 'User switched application to',
    APP_CRASH_REBOOT: 'Application crash reboot',
    API_STEP: 'API step performed',
    SWIPE: 'Swipe performed',
    CLEAR_TEXT: 'Clear text button pressed',
    ADD_TEST_DATA: 'Added test data variable:',
    SET_TEXT: 'Text set in form-field:',
    SAVE_API_STEP_VARIABLE: 'Saved API variable:',
    SET_API_STEP_VARIABLE: 'Set API variable:',
    SAVE_TEST_CASE_VARIABLE: 'Saved test case variable:',
    OVERRIDE_TEST_DATA_VARIABLE:'Test Case Variable',
    OVERRIDE_TEST_CASE_VARIABLE:'Test Case Variable',
    OVERRIDE_ARITHMETIC_VARIABLE:'Test Case Variable',
    OVERRIDE_API_VARIABLE:'Test Case Variable',
    SET_TEST_CASE_VARIABLE: 'Set test case variable:',
    SET_ARITHMETIC_VARIABLE: 'Set arithmetic variable',
    SEND_ASSERT_API_STEP_VARIABLE: '',
    UNEXPECTED_SCREEN: 'Unexpected Screen',
    LOADING_WAIT: 'Loading wait',
    DEEP_LINK: 'Deep Link',
    DEEP_LINK_WITH_VARIABLE: 'Deep Link with variable',
  }

  public static ACTION_NAMES: Record<string, string> = {
    NO_OP: 'NO OP',
    APP_LAUNCH: 'APP Launch',
    BACK_KEY: 'Back Key',
    SWIPE: 'SWIPE',
    SWIPE_TILL_ELEMENT: 'Swipe Until',
    VARIABLE_COMPARISON: 'Compare Variable',
    CLICK: 'Click',
    LONG_CLICK: 'Long Click',
    UNEXPECTED_SCREEN: 'Unexpected Screen',
    APP_CLOSED: 'APP Closed',
    LOADING_WAIT: 'Loading Wait',
    ENTER_KEY: 'Enter Key',
    RESET_APP: 'Reset APP',
    HOME_KEY: 'Home Key',
    ASSERTION: 'Assertion',
    ASSERT: 'Assert',
    ASSERT_EXISTS_EXACT_MATCH: 'Assert',
    ASSERT_EQUALS_EXACT_MATCH: 'Assert',
    ASSERT_NOT_EQUALS_EXACT_MATCH: 'Assert',
    ASSERT_EXISTS_SIMILAR: 'Assert',
    ASSERT_EQUALS_SIMILAR: 'Assert',
    ASSERT_NOT_EQUALS_SIMILAR: 'Assert',
    CLEAR_TEXT: 'Clear Text',
    ASSERT_ENABLED: 'Assert',
    ASSERT_NOT_ENABLED: 'Assert',
    ASSERT_CHECKED: 'Assert',
    ASSERT_UNCHECKED: 'Assert',
    ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH: 'Assert',
    ASSERT_TEST_CASE_VARIABLE: 'Assert',
    ASSERT_API_STEP_VARIABLE: 'Assert',
    ASSERT_VISUAL_MATCH: 'Assert',
    ASSERT_NOT_EXISTS_EXACT_MATCH: 'Assert',
    ASSERT_TEST_DATA_VARIABLE_NOT_EXACT_MATCH: 'Assert',
    ASSERT_TEST_CASE_VARIABLE_NOT_EXACT_MATCH: 'Assert',
    ASSERT_API_STEP_VARIABLE_NOT_EXACT_MATCH: 'Assert',
    ASSERT_TEST_DATA_VARIABLE_EQUALS_SIMILAR: 'Assert',
    ASSERT_TEST_CASE_VARIABLE_EQUALS_SIMILAR: 'Assert',
    ASSERT_API_STEP_VARIABLE_EQUALS_SIMILAR: 'Assert',
    ASSERT_TEST_DATA_VARIABLE_NOT_EQUALS_SIMILAR: 'Assert',
    ASSERT_TEST_CASE_VARIABLE_NOT_EQUALS_SIMILAR: 'Assert',
    ASSERT_API_STEP_VARIABLE_NOT_EQUALS_SIMILAR: 'Assert',
    ASSERT_ARITHMETIC_VARIABLE: 'Assert',
    ASSERT_ARITHMETIC_VARIABLE_NOT_EXACT_MATCH: 'Assert',
    ASSERT_ARITHMETIC_VARIABLE_EQUALS_SIMILAR: 'Assert',
    ASSERT_ARITHMETIC_VARIABLE_NOT_EQUALS_SIMILAR: 'Assert',
    TOGGLE_WIFI: 'Toggle Wifi',
    TIME_DELAY: 'Time Delay',
    DOUBLE_CLICK: 'Double Click',
    ROTATE_DEVICE: 'Rotate Device',
    APP_CRASH_REBOOT: 'APP Crash',
    ISSUE: 'Issue',
    DEEP_LINK: 'Deep Link',
    ZOOM_IN: "Zoom In",
    ZOOM_OUT: "Zoom Out",
    DEEP_LINK_WITH_VARIABLE: 'Deep Link with variable',
    // Set Text Actions.
    SET_TEXT: 'Set Text',
    ADD_TEST_DATA: 'Add Test Data',
    DRAG_AND_DROP: 'Drag and Drop',
    SET_API_STEP_VARIABLE: 'Set API Step Variable',
    SET_TEST_CASE_VARIABLE: 'Set Test Case Variable',
    SET_ARITHMETIC_VARIABLE: 'Set Arithmetic Variable',
    OVERRIDE_TEST_DATA_VARIABLE:'Test Case Variable',
    OVERRIDE_TEST_CASE_VARIABLE:'Test Case Variable',
    OVERRIDE_ARITHMETIC_VARIABLE:'Test Case Variable',
    OVERRIDE_API_VARIABLE:'Test Case Variable',
    SWITCH_NETWORK: 'Switch Network',
    SAVE_TEST_CASE_VARIABLE: 'Save Test Case Variable',
    API_STEP: 'API Step',
    SAVE_API_STEP_VARIABLE: 'Save API Step Variable',
    SEND_ASSERT_API_STEP_VARIABLE: 'Send Assert API Step Variable',
    TEMPLATE: 'Template',
    DISABLED_STEP: 'Disabled Step',
    APP_SWITCHER: 'APP Switcher',
    MockGPSLocation: 'Mock GPS Location',
    ARITHMETIC_STEP: 'Arithmetic Step',
    ASSERT_NUMERIC_EQUAL: 'Assert',
    ASSERT_NUMERIC_GREATER: 'Assert',
    ASSERT_NUMERIC_GREATER_EQUAL: 'Assert',
    ASSERT_NUMERIC_LESSER: 'Assert',
    ASSERT_NUMERIC_LESSER_EQUAL: 'Assert',
    ASSERT_NUMERIC_INBETWEEN: 'Assert',
    ASSERT_NUMERIC_EQUAL_TEST_DATA_VARIABLE: 'Assert',
    ASSERT_NUMERIC_GREATER_TEST_DATA_VARIABLE: 'Assert',
    ASSERT_NUMERIC_GREATER_EQUAL_TEST_DATA_VARIABLE: 'Assert',
    ASSERT_NUMERIC_LESSER_TEST_DATA_VARIABLE: 'Assert',
    ASSERT_NUMERIC_LESSER_EQUAL_TEST_DATA_VARIABLE: 'Assert',
    ASSERT_NUMERIC_INBETWEEN_TEST_DATA_VARIABLE: 'Assert',
    ASSERT_NUMERIC_EQUAL_ARITHMETIC_VARIABLE: 'Assert',
    ASSERT_NUMERIC_GREATER_ARITHMETIC_VARIABLE: 'Assert',
    ASSERT_NUMERIC_GREATER_EQUAL_ARITHMETIC_VARIABLE: 'Assert',
    ASSERT_NUMERIC_LESSER_ARITHMETIC_VARIABLE: 'Assert',
    ASSERT_NUMERIC_LESSER_EQUAL_ARITHMETIC_VARIABLE: 'Assert',
    ASSERT_NUMERIC_INBETWEEN_ARITHMETIC_VARIABLE: 'Assert',
    UI_VALIDATION_STEP: 'UI Validation',
    PASTE_FROM_CLIPBOARD: 'PASTE FROM CLIPBOARD',
    DOUBLE_FINGER_LONG_PRESS: 'Double Press',
    OPEN_NOTIFICATIONS: 'Open Pane',
    CLOSE_NOTIFICATIONS: 'Close Pane'
  }
  
  public static VARIABLE_ACTIONS = [
    'ADD_TEST_DATA',
    'SAVE_API_STEP_VARIABLE',
    'SET_API_STEP_VARIABLE',
    'SAVE_TEST_CASE_VARIABLE',
    'DEEP_LINK_WITH_VARIABLE',
    'OVERRIDE_TEST_DATA_VARIABLE',
    'OVERRIDE_TEST_CASE_VARIABLE',
    'OVERRIDE_ARITHMETIC_VARIABLE',
    'OVERRIDE_API_VARIABLE',
    'SET_TEST_CASE_VARIABLE',
    'SET_ARITHMETIC_VARIABLE',
    'SEND_ASSERT_API_STEP_VARIABLE',
    'ASSERT_EXISTS_EXACT_MATCH',
    'ASSERT_EQUALS_EXACT_MATCH',
    'ASSERT_NOT_EQUALS_EXACT_MATCH',
    'ASSERT_EXISTS_SIMILAR',
    'ASSERT_EQUALS_SIMILAR',
    'ASSERT_NOT_EQUALS_SIMILAR',
    'ASSERT_ENABLED',
    'ASSERT_NOT_ENABLED',
    'ASSERT_CHECKED',
    'ASSERT_UNCHECKED',
    'ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH',
    'ASSERT_TEST_CASE_VARIABLE',
    'ASSERT_API_STEP_VARIABLE',
    'ASSERT_NOT_EXISTS_EXACT_MATCH',
    'ASSERT_TEST_DATA_VARIABLE_NOT_EXACT_MATCH',
    'ASSERT_TEST_CASE_VARIABLE_NOT_EXACT_MATCH',
    'ASSERT_API_STEP_VARIABLE_NOT_EXACT_MATCH',
    'ASSERT_TEST_DATA_VARIABLE_EQUALS_SIMILAR',
    'ASSERT_TEST_CASE_VARIABLE_EQUALS_SIMILAR',
    'ASSERT_API_STEP_VARIABLE_EQUALS_SIMILAR',
    'ASSERT_TEST_DATA_VARIABLE_NOT_EQUALS_SIMILAR',
    'ASSERT_TEST_CASE_VARIABLE_NOT_EQUALS_SIMILAR',
    'ASSERT_API_STEP_VARIABLE_NOT_EQUALS_SIMILAR',
  ]

  public static SUB_ASSERTS = [
    "Should be equal",
    "Should not be equal",
    "Should contain",
    "Should not contain",
  ];
  public static TEST_CASE_DETAIL = [
    "Take a moment to scroll through all of your test steps. Click on any step to make an edit to a target or action, and you can also validate your run to ensure your sequence finishes.",
  ];
  // ASSERT ENGINE
  public static ASSERT_ENGINE_ACTIONS_DROPDOWN = [
    "Component",
    "Text",
    "Numeric",
  ];
  public static ASSERT_TYPES = [
    "COMPONENT",
    "VISUAL",
    "ATTRIBUTE",
  ]
  public static ASSERT_ENGINE_COMPONENT_ACTIONS = [
    "is present",
    "is not present",
    "is enabled",
    "is disabled",
    "is checked",
    "is unchecked",
  ];
  public static ASSERT_ENGINE_TEXT_ACTIONS = ["has content"];
  public static ASSERT_ENGINE_NUMERIC_ACTIONS = [
    "is equal to",
    "is greater than",
    "is greater than or equal to",
    "is less than",
    "is less than or equal to",
    "is in-between",
  ];
  public static NUMERIC_ASSERT_INBETWEEN = [
    "is in-between",
    "IS_INBETWEEN"
  ]
  public static NUMERIC_ASSERT_ACTIONS = [
    "Test component is equal to",
    "Test component is greater than",
    "Test component is greater than or equal to",
    "Test component is less than",
    "Test component is less than or equal to",
    "Test component is in-between",
    "Numeric Test component is equal to data variable",

    "Numeric Test component is greater than data variable",
    "Numeric Test component is greater than or equal to data variable",
    "Numeric Test component is less than data variable",
    "Numeric Test component is less than or equal to data variable",
    "Numeric Test component is in-between data variable",
  ];
  public static ASSERT_ENGINE_ACTIONS = ["Fail Test", "Warn and Continue"];
  public static NAVIGATION_URL = {
    LOCALHOST: "http://localhost:4100/app/",
    DEV_TEST: "https://devtest.sofy.ai/app/",
    PRE_PROD: "https://portal-sofy-stag-01-pre-prod.azurewebsites.net/app/",
    PROD: "https://portal.sofy.ai/app/",
  };
  public static VARIABLE_DATA_TYPE = {
    STRING: "String",
    INTEGER: "Integer",
    FLOAT: "Float",
    NUMERIC: "Numeric",
  };
  public static VARIABLE_DATA_TYPE_LIST = [
    {
      title: this.VARIABLE_DATA_TYPE.STRING,
      value: this.VARIABLE_DATA_TYPE.STRING,
    },
    {
      title: this.VARIABLE_DATA_TYPE.INTEGER,
      value: this.VARIABLE_DATA_TYPE.INTEGER,
    },
    {
      title: this.VARIABLE_DATA_TYPE.FLOAT,
      value: this.VARIABLE_DATA_TYPE.FLOAT,
    },
    {
      title: this.VARIABLE_DATA_TYPE.NUMERIC,
      value: this.VARIABLE_DATA_TYPE.NUMERIC,
    }
  ];
  public static  PATTERN_DATA_TYPE_LIST =  [
    {
      title: this.VARIABLE_DATA_TYPE.STRING,
      value: this.VARIABLE_DATA_TYPE.STRING,
    },
    {
      title: this.VARIABLE_DATA_TYPE.INTEGER,
      value: this.VARIABLE_DATA_TYPE.INTEGER,
    }
  ];
    public static DROPDOWN_VARIABLE_TYPE = {
    TEST_DATA: 'testData',
    API: 'api',
    SESSION: 'session',
    ARITHMETIC: 'arithmetic',
    TEMPLATE: 'template',
  };
  // Auto-handle system dialog response strategies
  public static AUTO_DIALOG_RESPONSE_MODES = {
    DEFAULT: "default" as AutoDialogResponseMode,
    ALL_POSITIVE: "all_positive" as AutoDialogResponseMode,
    ALL_NEGATIVE: "all_negative" as AutoDialogResponseMode,
  };
  public static MAP_CONDITIONAL_ACTION_VALUES: Record<string, string>= {
    true: 'Skip This Step',
    false: 'Execute Step as Recorded',
  };
  public static VARIABLE_TYPE_MAPPING = {
    'session': 'test case',
    'test data': 'data',
    'api': 'api',
    'data': 'data',
    'arithmetic' :'arithmetic'
  }
  public static DUMMY_COMPONENT:any = {
    "package": "dummy",
    "instance": 0,
    "type": "unknown",
    "index": 0,
    "xpath": "//hierarchy[1]/dummy[1]",
    "clazz": "dummy",
    "content_desc": "",
    "bounds": "[0,0][0,0]",
    "enabled": false,
    "clickable": false,
    "checked": false,
    "scrollable": false,
    "resource_id": "dummy",
    "checkable": false,
    "password": false,
    "focusable": false,
    "selected": false,
    "focused": false,
    "componentId": 765
  } 

  public static DISABLED_ASSERT =[
    'APP_LAUNCH',
    'ROTATE_DEVICE',
    'APP_SWITCHER',
    'API_STEP',
    'OVERRIDE_TEST_DATA_VARIABLE',
    'OVERRIDE_TEST_CASE_VARIABLE',
    'OVERRIDE_ARITHMETIC_VARIABLE',
    'OVERRIDE_API_VARIABLE',
  ]
  
  public static ASSERT_TYPE_MAPPING = {
    ATTRIBUTE: 'Component',
    TEXT: 'Text',
    NUMERIC: 'Numeric',
    COMPONENT: 'Component',
    VISUAL: 'Visual',
  } 

  public static ASSERT_TYPE = {
    ATTRIBUTE: 'ATTRIBUTE',
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    COMPONENT: 'COMPONENT',
    VISUAL: 'VISUAL',
  } 

  public static ASSERT_SUBACTION_MAPPING = {
    // TEXT ASSERT
    SHOULD_BE_EQUAL: 'Should be equal',
    SHOULD_NOT_BE_EQUAL: 'Should not be equal',
    SHOULD_CONTAIN: 'Should contain',
    SHOULD_NOT_CONTAIN: 'Should not contain',
    IS_EQUAL_TO: 'is equal to',

    // NUMERIC ASSERT
    IS_GREATER_THAN: 'is greater than',
    IS_GREATER_THAN_OR_EQUAL_TO: 'is greater than or equal to',
    IS_LESS_THAN: 'is less than',
    IS_LESS_THAN_OR_EQUAL_TO: 'is less than or equal to',
    IS_INBETWEEN: 'is in-between',

    // COMPONENT ASSERT
    IS_PRESENT: 'is present',
    IS_NOT_PRESENT: 'is not present',
    IS_ENABLED: 'is enabled',
    IS_DISABLED: 'is disabled',
    IS_CHECKED: 'is checked',
    IS_UNCHECKED: 'is unchecked',

   // conditional 
   HAS_CONTENT: 'has content', 

   // VARIABLE CONDITIONAL
   CONTENT_EQUALS: 'Content Equals',
   CONTENT_DOES_NOT_EQUAL: 'Content Does Not Equal',
   CONTENT_CONTAINS: 'Content Contains',
   CONTENT_DOES_NOT_CONTAIN: 'Content Does Not Contain'
  }

  public static REVERSE_ASSERT_SUBACTION_MAPPING = {
    // TEXT ASSERT
    'Should be equal': 'SHOULD_BE_EQUAL',
    'Should not be equal': 'SHOULD_NOT_BE_EQUAL',
    'Should contain': 'SHOULD_CONTAIN',
    'Should not contain': 'SHOULD_NOT_CONTAIN',
    'is equal to': 'IS_EQUAL_TO',

    // NUMERIC ASSERT
    'is greater than': 'IS_GREATER_THAN',
    'is greater than or equal to': 'IS_GREATER_THAN_OR_EQUAL_TO',
    'is less than':'IS_LESS_THAN',
    'is less than or equal to': 'IS_LESS_THAN_OR_EQUAL_TO',
    'is in-between': 'IS_INBETWEEN',

    // COMPONENT ASSERT
    'is present': 'IS_PRESENT',
    'is not present': 'IS_NOT_PRESENT',
    'is enabled': 'IS_ENABLED',
    'is disabled': 'IS_DISABLED',
    'is checked': 'IS_CHECKED',
    'is unchecked': 'IS_UNCHECKED',

    // CONDITIONAL 
    'has content': 'HAS_CONTENT',

    // VARIABLE CONDITIONAL
    'Content Equals': 'CONTENT_EQUALS',
    'Content Does Not Equal': 'CONTENT_DOES_NOT_EQUAL',
    'Content Contains': 'CONTENT_CONTAINS',
    'Content Does Not Contain': 'CONTENT_DOES_NOT_CONTAIN',
  }

  public static NEW_OVERRIDE_VARIABLE_STEP_DATA = {
    action_type: "OVERRIDE_TEST_DATA_VARIABLE",
    action_value: "",
    activity_name: null,
    device_metrics: {
      device_name: null,
      device_resolution: null
    },
    step_screenshot: {
      url: "STEP_SCREENSHOT_PLACEHOLDER",
      dimensions: [
        0,
        0
      ],
      bounds: [
        0,
        0,
        0,
        0
      ],
      mouse_events: []
    },
    step_flags: {
      is_variable_used: false,
      is_step_disabled: false
    },
    optional_subactions: {
      override_variable_details: {
        test_data_id: 0,
        override_value: "",
      }
    },
    selected_component: {},
  }
  public static DEFAULT_DEVICE_IMAGE =
  'https://portalvhdsld5gs9t7pkkvf.blob.core.windows.net/qbot/Images/no_image_selected.png';
  
  public static STEPRESULT = {
    FAIL: 'Failed',
    WARNING: 'Warning',
    PASS: 'Passed',
  }

  public static ACTION_RESULT = {
    PASS: 'PASS',
    WARNING: 'WARNING',
    FAILED: 'FAILED',
    FAIL: 'FAIL',
  };

  public static UPDATE_TESTCASE_TYPES = {
    step_addition: "step_addition",
    step_updation: "step_updation",
    step_api_updation: "step_api_updation",
    step_disable: "step_disable",
    step_deletion: "step_deletion",
  }

  public static TEST_CASE_STATUS = {
    DRAFT: 'Draft',
    READY: 'Ready'
  }

  public static TEST_SCENARIO_URL = {
    SCENARIO_RUN_URL:
      'https://portalvhdsld5gs9t7pkkvf.blob.core.windows.net/qbot/quantyzdandroidruns/Scenarios/',
    BASE_SCENARIO_RUN_URL:
      'https://portalvhdsld5gs9t7pkkvf.blob.core.windows.net/qbot/Plugin/TrainingScenarios/',
  };

  public static NEW_TIME_DELAY_STEP_DATA =  {
    action_type: "TIME_DELAY",
    action_value: "",
    activity_name: "",
    device_metrics: {
      device_name: null,
      device_resolution: null
    },
    step_screenshot: {
      url: "STEP_SCREENSHOT_PLACEHOLDER",
      dimensions: [
        540,
        1200
      ],
      bounds: [
        0,
        0,
        0,
        0
      ],
      mouse_events: []
    },
    step_flags: {
      is_variable_used: false,
      is_step_disabled: false
    },
    optional_subactions: {
    },
  }

  // Rule dependency configuration for recommendation steps
  public static RECOMMENDATION_RULE_DEPENDENCIES = {
    LARGE_BOUNDING_BOX: {
      dependsOn: [],
      blocks: ['WEAK_MATCHING_ATTRIBUTES'],
      optionalSubActionsBypassRecommendation: ['visual_match_details'],
      stepActionBypassRecommendation: []
    },
    WEAK_MATCHING_ATTRIBUTES: {
      dependsOn: ['LARGE_BOUNDING_BOX'],
      blocks: [],
      optionalSubActionsBypassRecommendation: ['visual_match_details'],
      stepActionBypassRecommendation: []
    },
    SAME_RESOURCE_ID: {
      dependsOn: [],
      blocks: [],
      optionalSubActionsBypassRecommendation: [''],
      stepActionBypassRecommendation: []
    }
  };

  public static UI_VALIDATOR_TYPES = [
    {title: 'Required Field Check', value: 'REQUIRED_FIELDS'},
    {title: 'Field Visible Check', value: 'VISIBLE_FIELDS'},
    { title: 'Tabs Visibility Check', value: 'TAB_VISIBILITY_FIELDS'},
    { title: 'Readonly Field Check', value: 'READONLY_FIELDS'},
  ]
   public static UI_VALIDATION_ACTIONS = [
  { title: 'Fail Test', value: 'FAIL' },
  { title: 'Warn and Continue', value: 'WARNING' },
  ];
  public static IU_VALIDATION_TYPE_MAPPING = {
    'REQUIRED_FIELDS': 'Required Field Check',
    'VISIBLE_FIELDS': 'Field Visible Check',
    "TAB_VISIBILITY_FIELDS": 'Tabs Visibility Check',
    "READONLY_FIELDS": 'Readonly Field Check',
  }
  public static UI_VALIDATOR_TYPES_MAP= {
    REQUIRED_FIELDS: 1,
    VISIBLE_FIELDS: 2,
    TAB_VISIBILITY_FIELDS: 3,
  };
}

export enum REVERSE_ASSERT_MAPPING {
  "Test component is present" = "ASSERT_EXISTS_EXACT_MATCH",
  "Test component is not present" = "ASSERT_NOT_EXISTS_EXACT_MATCH",
  "Test component is enabled" = "ASSERT_ENABLED",
  "Test component is disabled" = "ASSERT_NOT_ENABLED",
  "Test component is checked" = "ASSERT_CHECKED",
  "Test component is unchecked" = "ASSERT_UNCHECKED",
  "ASSERT_EXISTS_SIMILAR" = "ASSERT_EXISTS_SIMILAR",
  "Should be equal" = "ASSERT_EQUALS_EXACT_MATCH",
  "Test component has content" = "COMPONENT_CONTAINS",
  "Should be equal test case variable" = "ASSERT_TEST_CASE_VARIABLE",
  "Should be equal variable" = "ASSERT_TEST_DATA_VARIABLE",
  "Should not be equal" = "ASSERT_NOT_EQUALS_EXACT_MATCH",
  "Should contain" = "ASSERT_EQUALS_SIMILAR",
  "Should be equal api variable" = "ASSERT_API_STEP_VARIABLE",
  "Should not contain" = "ASSERT_NOT_EQUALS_SIMILAR",
  "Should be equal data variable" = "ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH",
  "Should not be equal data variable" = "ASSERT_TEST_DATA_VARIABLE_NOT_EXACT_MATCH",
  "Should contain data variable" = "ASSERT_TEST_DATA_VARIABLE_EQUALS_SIMILAR",
  "Should contain test case variable" = "ASSERT_TEST_CASE_VARIABLE_EQUALS_SIMILAR",
  "Should contain api variable" = "ASSERT_API_STEP_VARIABLE_EQUALS_SIMILAR",
  "Should not equal api variable" = "ASSERT_API_STEP_VARIABLE_NOT_EXACT_MATCH",
  "Should not contain data variable" = "ASSERT_TEST_DATA_VARIABLE_NOT_EQUALS_SIMILAR",
  "Should not contain test case variable" = "ASSERT_TEST_CASE_VARIABLE_NOT_EQUALS_SIMILAR",
  "Should not contain api variable" = "ASSERT_API_STEP_VARIABLE_NOT_EQUALS_SIMILAR",
  "Should not be equal test case variable" = "ASSERT_TEST_CASE_VARIABLE_NOT_EXACT_MATCH",
  "Should not be equal to api variable" = "ASSERT_API_STEP_VARIABLE_NOT_EQUALS_EXACT_MATCH",
  "Should not be equal to test case variable" = "ASSERT_TEST_CASE_VARIABLE_NOT_EQUALS_EXACT_MATCH",
  "Test component is equal to" = "ASSERT_NUMERIC_EQUAL",
  "Test component is greater than" = "ASSERT_NUMERIC_GREATER",
  "Test component is greater than or equal to" = "ASSERT_NUMERIC_GREATER_EQUAL",
  "Test component is less than" = "ASSERT_NUMERIC_LESSER",
  "Test component is less than or equal to" = "ASSERT_NUMERIC_LESSER_EQUAL",
  "Test component is in-between" = "ASSERT_NUMERIC_INBETWEEN",
  "Numeric Test component is equal to data variable" = "ASSERT_NUMERIC_EQUAL_TEST_DATA_VARIABLE",
  "Numeric Test component is greater than data variable" = "ASSERT_NUMERIC_GREATER_TEST_DATA_VARIABLE",
  "Numeric Test component is greater than or equal to data variable" = "ASSERT_NUMERIC_GREATER_EQUAL_TEST_DATA_VARIABLE",
  "Numeric Test component is less than data variable" = "ASSERT_NUMERIC_LESSER_TEST_DATA_VARIABLE",
  "Numeric Test component is less than or equal to data variable" = "ASSERT_NUMERIC_LESSER_EQUAL_TEST_DATA_VARIABLE",
  "Numeric Test component is in-between data variable" = "ASSERT_NUMERIC_INBETWEEN_TEST_DATA_VARIABLE",
  "Numeric Test component is equal to arithmetic variable" = "ASSERT_NUMERIC_EQUAL_ARITHMETIC_VARIABLE",
  "Numeric Test component is greater than arithmetic variable" = "ASSERT_NUMERIC_GREATER_ARITHMETIC_VARIABLE",
  "Numeric Test component is greater than or equal to arithmetic variable" = "ASSERT_NUMERIC_GREATER_EQUAL_ARITHMETIC_VARIABLE",
  "Numeric Test component is less than arithmetic variable" = "ASSERT_NUMERIC_LESSER_ARITHMETIC_VARIABLE",
  "Numeric Test component is less than or equal to arithmetic variable" = "ASSERT_NUMERIC_LESSER_EQUAL_ARITHMETIC_VARIABLE",
  "Numeric Test component is in-between arithmetic variable" = "ASSERT_NUMERIC_INBETWEEN_ARITHMETIC_VARIABLE",
};

const PROJECT_NAME = "LAB";

const SUBSCRIPTIONS = {
  INHOUSE: "INHOUSE",
  ENTERPRISE: "ENTERPRISE",
  TRIAL: "TRIAL",
};

const INTERNET_STATUS = {
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
  SLOW: "SLOW",
  COULD_NOT_DETECT: "COULD_NOT_DETECT",
  RECONNECTED: "RECONNECTED",
};

const INTERNET_STATUS_EVENTS = {
  SLOW_INTERNET: "SLOW_INTERNET",
  INTERNET_RECONNECTED: "INTERNET_RECONNECTED",
  COULD_NOT_DETECT_INTERNET_SPEED: "COULD_NOT_DETECT_INTERNET_SPEED",
  INTERNET_SPEED_AT_START: "INTERNET_SPEED_AT_START",
};

const ISSUETYPES = [
  {
    key: 'DEFECT',
    value: 'Defect',
  },
  {
    key: 'BUG',
    value: 'Bug',
  },
  {
    key: "PRODUCTION",
    value: "Product Issue",
  },
  {
    key: "TEST",
    value: "Test Issue",
  },
  {
    key: "PERFORMANCE",
    value: "Performance",
  },
  {
    key: "VISUALQUALITY",
    value: "Visual Quality",
  },
  {
    key: "CRASH",
    value: "Crash",
  },
  {
    key: "FUNCTIONAL",
    value: "Functional",
  },
  {
    key: "NON-FUNCTIONAL",
    value: "Non-Functional",
  },
];

const REQUEST_TYPES = {
  get: "GET",
  post: "POST",
  put: "PUT",
  patch: "PATCH",
  delete: "DELETE",
};

enum RESULTS_PLAYBACK_STATUS {
  "passed" = 1,
  "passed_with_errors" = 1,
  "passed_with_warnings" = 1,
  "failed" = 0,
  "incomplete" = 2,
  "in_complete" = 2,
  "not executed" = 2,
  "inprogress" = 3,
  "running" = 3,
  "in_progress" = 3,
  "submitted for qbot" = 4,
  "internal_failed" = 5,
  "install_failed_invalid_provisioning_profile" = 6,
  "failed_controller_restart" = 7,
  "failed-session expired" = 8,
  "install_failed" = 7,
  "install_failed_no_matching_abis" = 7,
  "failed_scenario_json_not_found" = 5,
}

enum RESULTS_STATUS_STRING {
  "passed" = "Test Cases Passed",
  "passed_with_errors" = "Passed With Warning",
  "passed_with_warnings" = "Passed With Warning",
  "failed" = "Test Cases Failed",
  "incomplete" = "Incomplete",
  "inprogress" = "In Progress",
  "not executed" = "Not Executed",
  "running" = "In Progress",
  "in_progress" = "In Progress",
  "submitted for qbot" = "In Queue",
  "internal_failed" = "Internal Failed",
  "install_failed_invalid_provisioning_profile" = "Invalid Profile",
  "failed_controller_restart" = "Failed Controller Restart",
  "failed-session expired" = "Failed, Session Expired",
  "install_failed" = "Installation Failed",
  "in_complete" = "Incomplete",
  "install_failed_no_matching_abis" = "Installation Failed",
  "failed_scenario_json_not_found" = "Internal Failed",
}

const DEVICE_ORIENTATION = {
  PORTRAIT: "Portrait",
  LANDSCAPE: "Landscape",
};

const MANUAL_TESTRUN_RESULTS = {
  FAILED: 0,
  PASSED: 1,
  CANCELLED: 2,
};
const LIST_OF_ASSERTS = [
  "ASSERTION",
  "ASSERT_EXISTS_EXACT_MATCH",
  "ASSERT_EQUALS_EXACT_MATCH",
  "ASSERT_NOT_EQUALS_EXACT_MATCH",
  "ASSERT_EXISTS_SIMILAR",
  "ASSERT_EQUALS_SIMILAR",
  "ASSERT_NOT_EQUALS_SIMILAR",
  "ASSERT_ENABLED",
  "ASSERT_NOT_ENABLED",
  "ASSERT_CHECKED",
  "ASSERT_UNCHECKED",
  "ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH",
  "ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH",
  "ASSERT_TEST_CASE_VARIABLE",
  "ASSERT_API_STEP_VARIABLE",
  "ASSERT_NOT_EXISTS_EXACT_MATCH",
  "ASSERT_ARITHMETIC_VARIABLE",
  "ASSERT_ARITHMETIC_VARIABLE_NOT_EXACT_MATCH",
  "ASSERT_ARITHMETIC_VARIABLE_EQUALS_SIMILAR",
  "ASSERT_ARITHMETIC_VARIABLE_NOT_EQUALS_SIMILAR",
  "ASSERT_TEST_DATA_VARIABLE_NOT_EXACT_MATCH",
  "ASSERT_TEST_CASE_VARIABLE_NOT_EXACT_MATCH",
  "ASSERT_API_STEP_VARIABLE_NOT_EXACT_MATCH",
  "ASSERT_TEST_DATA_VARIABLE_EQUALS_SIMILAR",
  "ASSERT_TEST_CASE_VARIABLE_EQUALS_SIMILAR",
  "ASSERT_API_STEP_VARIABLE_EQUALS_SIMILAR",
  "ASSERT_TEST_DATA_VARIABLE_NOT_EQUALS_SIMILAR",
  "ASSERT_TEST_CASE_VARIABLE_NOT_EQUALS_SIMILAR",
  "ASSERT_API_STEP_VARIABLE_NOT_EQUALS_SIMILAR",
  "ASSERT_API_STEP_VARIABLE_NOT_EXACT_MATCH",
  "ASSERT_NUMERIC_EQUAL",
  "ASSERT_NUMERIC_GREATER",
  "ASSERT_NUMERIC_GREATER_EQUAL",
  "ASSERT_NUMERIC_LESSER",
  "ASSERT_NUMERIC_LESSER_EQUAL",
  "ASSERT_NUMERIC_INBETWEEN",
  "ASSERT_NUMERIC_EQUAL_TEST_DATA_VARIABLE",
  "ASSERT_NUMERIC_GREATER_TEST_DATA_VARIABLE",
  "ASSERT_NUMERIC_GREATER_EQUAL_TEST_DATA_VARIABLE",
  "ASSERT_NUMERIC_LESSER_TEST_DATA_VARIABLE",
  "ASSERT_NUMERIC_LESSER_EQUAL_TEST_DATA_VARIABLE",
  "ASSERT_NUMERIC_INBETWEEN_TEST_DATA_VARIABLE",
  "ASSERT_NUMERIC_EQUAL_ARITHMETIC_VARIABLE",
  "ASSERT_NUMERIC_GREATER_ARITHMETIC_VARIABLE",
  "ASSERT_NUMERIC_GREATER_EQUAL_ARITHMETIC_VARIABLE",
  "ASSERT_NUMERIC_LESSER_ARITHMETIC_VARIABLE",
  "ASSERT_NUMERIC_LESSER_EQUAL_ARITHMETIC_VARIABLE",
  "ASSERT_NUMERIC_INBETWEEN_ARITHMETIC_VARIABLE",
];

export const TEST_DATA_PATTERNS = {
  NUMERIC: "{{ numeric(n) }}",
  ALPHABETIC: "{{ alphabetic(n) }}",
  ALPHANUMERIC: "{{ alphanumeric(n) }}",
  DATE: "{{ date(n, DD-MM-YYYY) }}",
};

export const TIMEREVENTS = {
  COMPLETED_SESSION: "EXPIRED",
  ENDED_SESSION: "SIGTERM",
  STARTED_SESSION: "START",
  RESET_SESSION: "RESET",
  UPDATE_SESSION: "UPDATE",
};
// "START", "SIGTERM", "EXPIRED", "RESET", "UPDATE"]

export const StepActions = {
  SET_lOCATION: "Set Location",
  SET_TEXT: 'Set Text',
  SWIPE_UNTIL: 'Swipe Until',
  ASSERT: 'Assert',
  THRESHOLD: 'Threshold',
  TEST_CASE_VARIABLE: 'Save Test Case Variable',
  ELEMENT_EXPLORER: 'Element Explorer',
  API_STEP: 'API Step',
  DELAY: 'Delay',
  TEST_DATA_VARIABLE: 'Test Data Variable',
  VARIABLE_COMPARISON: 'Compare Variable',
  DEEP_LINK: 'Execute Deep Link',
  DEEP_LINK_WITH_VARIABLE: 'Execute Deep Link with Variable',
  ARITHMETIC_EXPRESSION: 'Arithmetic Expression'
}

export const IDEMessageTypes = {
  FETCH_DATA_RESP: "fetch_data_resp",
  STATUS: "Status:",
  DOWNLOAD_DOWNLOAD: "Download-Download:",
  GET_THIRD_PARTY_APP: "GetThirdPartyApp",
  DOWNLOAD: "Download",
  PLAYBACK: "Playback",
  VALIDATION: "Validation",
  UPLOAD_APP: "UploadApp",
  DEVICE_LOG: "DeviceLog:",
  API_LOGS_STARTED: "Started App API Log streaming",
  HTTP_LOGS_STARTED: "Started HTTPS Log Streaming",
  BUG_REPORT: "BugReport:",
  SAVE_SCENARIO: "SaveScenario",
  APPLICATION_STATE: "ApplicationState",
  END_SESSION: "end_session:true",
  DELETE_STEP_SUCCESSFUL: "Step Deleted Successfully",  //Step Deletion Successful message during the recording
  DELETE_STEP_FAILED: "Delete Step Failed due to Invalid Index", //Delete Step Failed due to invalid index during the recording
  EDIT_STEP_FAILED: 'EditStep:Failed',
  STATUS_CHECK: "status",
  UPLOAD_SCENARIO: "UploadScenario",
  SCENARIO_GUID: "Scenario GUID: ",
  TEMPLATE_GUID: "Template GUID: ",
  TRAINING_SCENARIO_ID: "TrainingScenarioId: ",
  FETCH_API_STEP_VARIABLES: "FetchAPIStepVariables",
  FETCH_TEST_CASE_VARIABLES: "FetchTestCaseVariables",
  PROMPT_RECORDING_COMPLETE: "promptRecord:complete",
  ACCESSABILITY_TEST_COMPLETE:
    "Accessibility Test Execution Complete for the current screen",
  ACCESSABILITY_TEST_START:
    "Starting Accessibility Test Execution for current screen",
  DRIVER_CRASHED_RESTARTING: "Driver Crashed, Restarting",
  RECOVERING_THE_DRIVER: "Recovering the driver, please standby",
  DRIVER_ONLINE: "Driver Online",
  DRIVER_RECOVERED_SUCCESSFULLY: "Driver Recovered Successfully",
  APP_FAIL: "Application load fail",
  ACCESSABILITY_REPORT_UPLOADED: "Uploaded Accessibility Reports Successfully ",
  ACCESSABILITY_REPORT_FAILED_TO_UPLOADED:
    "Failed to upload Accessibility Reports",
  ACCESSABILITY_REPORT_GUID: "report_guid",
  NETWORK_LOG_UPLOADED: "NetworkLogUploaded:",
  SWIPE_UNTIL_COMPONENT_DETAILS: "Clicked_Component_Details_For_SwipeUntil_in_Lab",
  SWIPE_UNTIL_SWIPE_COUNT: "Swipe performed successfully, swipe_count:",
  SWIPE_UNTIL_START:"Swipe Until Mode Started",
  SWIPE_UNTIL_CANCELLED:"Swipe Until Step Cancelled",
  SWIPE_UNTIL_SAVED:"Saved Swipe Until Step",
  POST_HOOK_TEMPLATE_ADDED: "PostHook Template added successfully",
  SCENARIO_SAVE_FAILED: "Exception in saving scenario",
  SCENARIO_SAVE_SUCCESSFULL: "Scenario Saved Successfully",
  APPIUM_CRASH: "Appium Server is unresponsive",
  PERFORMING_TOUCH_ACTION: "Performing Touch Action",
  XML_FETCHED: "XML fetched for action",
  SWIPE_PERFORMED: "Swipe successfully performed",
  SCENARIO_NOT_UPLOAD: "Scenario Not Uploaded",
  DRAG_DROP_PERFORMED: "Drag and Drop performed successfully"
};

export const IDEPlayBackMessageTypes = {
  PLAYBACK_STARTED: "Started",
  PLAYBACK_COMPLETED: "Playback: completed",
  PLAYBACK_STOPPED: "Playback: stopped",
  VALIDATION_STOPPED: "Validation: stopped",
  PLAYBACK_FAILED: "Playback: failed",
  PLAYBACK_UPLOADING_RESULTS: "Uploading results",
  PLAYBACK_UPLOADED_RESULTS: "Uploaded",
  VALIDATION_FAILED: "Validation: failed",
  VALIDATION_COMPLETED: "Validation: completed",
};

export const NetworkProfiles = [
  {
    name: "Default",
    speed: "-",
    port: "-",
    dropRate: "0",
    concurrency: "-",
    close: false,
    sleep: "0",
  },
  {
    name: "2G-Average",
    speed: "3000",
    port: "5000",
    dropRate: "0",
    concurrency: "500",
    close: false,
    sleep: "0",
  },
  {
    name: "2G-Good",
    speed: "6000",
    port: "5001",
    dropRate: "0",
    concurrency: "500",
    close: false,
    sleep: "0",
  },
  {
    name: "3G-Average",
    speed: "50000",
    port: "5002",
    dropRate: "0",
    concurrency: "500",
    close: false,
    sleep: "0",
  },
  {
    name: "4G-Low",
    speed: "100000",
    port: "5003",
    dropRate: "0",
    concurrency: "500",
    close: false,
    sleep: "0",
  },
  {
    name: "4G-Good",
    speed: "200000",
    port: "5004",
    dropRate: "0",
    concurrency: "500",
    close: false,
    sleep: "0",
  },
  {
    name: "Broadband-Average",
    speed: "400000",
    port: "5005",
    dropRate: "0",
    concurrency: "500",
    close: false,
    sleep: "0",
  },
  {
    name: "Broadband-Good",
    speed: "800000",
    port: "5006",
    dropRate: "0",
    concurrency: "500",
    close: false,
    sleep: "0",
  },
];

export const AppUploadErrorMsg = {
  UNSUPPORTED_FILES_UPLOADED:
    "Files with extensions other than APK or IPA are not supported. Reupload after ensuring that the extension and type of the application file being uploaded is either an apk or an ipa.",
  WRONG_FILE_UPLOADED_FOR_ANDROID:
    "Cannot upload IPA files on Android sessions.",
  WRONG_FILE_UPLOADED_FOR_IOS: "Cannot upload APK files on iOS sessions.",
  SUBSCRIPTIONS_PLAN_ERROR:
    "Your subscription plan does not support the uploaded application build type. You can either upload the file type specified in your subscription or modify your subscription by reaching out",
  APPLICATION_LIMIT_EXCEED:
    "You have reached the maximum number of allowed applications for this subscription. In order to extend the Application upload limit, please reach out",
};

export {
  PROJECT_NAME,
  REQUEST_TYPES,
  INTERNET_STATUS,
  INTERNET_STATUS_EVENTS,
  ISSUETYPES,
  MANUAL_TESTRUN_RESULTS,
  DEVICE_ORIENTATION as DEVICE_ORIENTATION,
  LIST_OF_ASSERTS,
  SUBSCRIPTIONS,
  RESULTS_STATUS_STRING,
  RESULTS_PLAYBACK_STATUS,
};

export const ReleaseMessages = {
  ACCESSIBILITY_RELEASE_MODAL:
    "This application does not have an active release, please create one before performing Accessibility Testing.",
  MANUAL_RELEASE_MODAL:
    "This application does not have an active release, please create one before executing a live or an automated test case.",
  Issue_RELEASE_MODAL:
    "This application does not have an active release, please create one before creating an issue.",
};

export const VARIABLE_TYPE = [
  { title: 'VALUE' ,value: "VALUE"},
  {  title: 'PATTERN', value: "PATTERN"},
  { value: "SECRET", title: 'SECRET' },
];

export const PATTERN_TYPE = [
  { value: "{{ numeric(n) }}", title: "{{ numeric(n) }}" },
  { value: "{{ alphabetic(n) }}", title: "{{ alphabetic(n) }}" },
  { value: "{{ alphanumeric(n) }}", title: "{{ alphanumeric(n) }}" },
  { value: "{{ date(n, DD-MM-YYYY) }}", title: "{{ date(n, DD-MM-YYYY) }}" },
];

export const DATE_FORMAT = [
  { title: "DD-MM-YYYY", value: "DD-MM-YYYY" },
  { title: "M/D/YYYY", value: "M/D/YYYY" },
  { title: "M/D/YY", value: "M/D/YY"},
  { title: "MM/DD/YYYY", value: "MM/DD/YYYY" },
  { title: "MM/DD/YY", value: "MM/DD/YY" },
  { title: "MMM D", value: "MMM D" },
  { title: "MMM DD", value: "MMM DD" },
  { title: "Month DD", value: "MMMM DD"},
  { title: "DD MMM YYYY", value: "DD MMM YYYY"},
  { title: "MMM DD, H:MM am/pm", value: "MMM DD, h:mm a" },
  { title: "MMM D, H:MM AM/PM", value: "MMM D, h:mm A" },
  { title: "MMM D at H:MM AM/PM", value: "MMM D [at] h:mm A" },
  { title: "DD/MM/YYYY", value: "DD/MM/YYYY" },
  { title: "DD/MM/YY", value: "DD/MM/YY" },
  { title: "YYYY/MM/DD", value: "YYYY/MM/DD" },
  { title: "YYYY-MM-DD", value: "YYYY-MM-DD" },
  { title: "D Only", value: "D" },
  { title: "DD Only", value: "DD" },
  { title: "MM Only", value: "MM" },
  { title: "Month Only", value: "MMMM" },
  { title: "YYYY Only", value: "YYYY" },
  { title: "Month DD, YYYY", value: "MMMM DD, YYYY" },
  { title: "DD Month YYYY", value: "DD MMMM YYYY" },
  { title: "DD, Month, YYYY", value: "DD, MMMM, YYYY" },
  { title: "D, Month, YYYY", value: "D, MMMM, YYYY" },
  { title: "Day, MMM D", value: "dddd, MMM D" },
  { title: "Day, Month D", value: "dddd, MMMM D" },
  { title: "Day D Month YYYY", value: "dddd D MMMM YYYY"},
  { title: "Day MMM DD", value: "dddd MMM DD" },
  { title: "DDD MMM DD", value: "ddd MMM DD" },
  { title: "MMDDYYYY", value:"MMDDYYYY"},
  { title: "DDMMYYYY", value:"DDMMYYYY"}
];

export const WEEK_DAYS = [
  { title: "Monday", value: 1 },
  { title: "Tuesday", value: 2 },
  { title: "Wednesday", value: 3 },
  { title: "Thursday", value: 4 },
  { title: "Friday", value: 5 },
  { title: "Saturday", value: 6 },
  { title: "Sunday", value: 0 },
]; //value is passed as string through event

export const ASSERT_MAPPING = [
  { code: "18", action: "is present" },
  { code: "29", action: "is not present" },
  { code: "25", action: "is enabled" },
  { code: "26", action: "is disabled" },
  { code: "1", action: "has content" },
  { code: "44", action: "Should be equal" },
  { code: "43", action: "Should not be equal" },
  { code: "22", action: "Should contain" },
  { code: "23", action: "Should not contain" },
  { code: "27", action: "is checked" },
  { code: "28", action: "is unchecked" },
  { code: "45", action: "is equal to" },
  { code: "46", action: "is greater than" },
  { code: "47", action: "is greater than or equal to" },
  { code: "48", action: "is less than" },
  { code: "49", action: "is less than or equal to" },
  { code: "50", action: "is in-between" },
];

export const ASSERT_TUPLES = [
  { code: "18", action: "ASSERT_EXISTS_EXACT_MATCH" },
  { code: "29", action: "ASSERT_NOT_EXISTS_EXACT_MATCH" },
  { code: "19", action: "ASSERT_EQUALS_EXACT_MATCH" },
  { code: "20", action: "ASSERT_NOT_EQUALS_EXACT_MATCH" },
  { code: "21", action: "ASSERT_EXISTS_SIMILAR" },
  { code: "22", action: "ASSERT_EQUALS_SIMILAR" },
  { code: "23", action: "ASSERT_NOT_EQUALS_SIMILAR" },
  { code: "25", action: "ASSERT_ENABLED" },
  { code: "26", action: "ASSERT_NOT_ENABLED" },
  { code: "27", action: "ASSERT_CHECKED" },
  { code: "28", action: "ASSERT_UNCHECKED" },
  { code: "34", action: "ASSERT_TEST_DATA_VARIABLE_EXACT_MATCH" },
  { code: "41", action: "ASSERT_TEST_CASE_VARIABLE" },
  { code: "42", action: "ASSERT_API_STEP_VARIABLE" },
  { code: "43", action: "ASSERT_NOT_EXACT_MATCH" },
  { code: "44", action: "ASSERT_EXACT_MATCH" },
  { code: "45", action: "ASSERT_NUMERIC_EQUAL" },
  { code: "46", action: "ASSERT_NUMERIC_GREATER" },
  { code: "47", action: "ASSERT_NUMERIC_GREATER_EQUAL" },
  { code: "48", action: "ASSERT_NUMERIC_LESSER" },
  { code: "49", action: "ASSERT_NUMERIC_LESSER_EQUAL" },
  { code: "50", action: "ASSERT_NUMERIC_INBETWEEN" },
];

export const STEP_ACTIONS = [
  { icon: 'atithmeticExpressionIcon', title: 'Arithmetic Expression', description: 'Calculate a value using a math expression'},
  { icon: 'swipeDown', title: 'Swipe Until', description: 'Automatically perform swipes until selected element is found' },
  { icon: 'assertIcon', title: 'Assert', description: 'Create asserts on any element that allow you to set conditions'},
  { icon: 'timeDelay', title: 'Delay', description: 'Add a delay (in ms) before or after the execution of a step' },
  { icon: 'SAVE_TEST_CASE_VARIABLE', title: 'Test Case Variable', description: 'Create a variable that will be used throughout this test case' },
  { icon: 'thresholdIcon', title: 'Threshold', description: 'Set alert thresholds for CPU and memory' },
  { icon: 'APIStepIcon', title: 'API Step', description: 'Define variables from an external API' },
  { icon: 'COMPARE_VARIABLE', title: 'Compare Variable', description: 'Compare 2 variables or a variable with text' },
];

export const INSERT_STEP_ACTIONS = [
  { icon: 'timeDelay', title: 'Delay', description: 'Add a delay (in ms) before or after the execution of a step' },
  { icon: 'SAVE_TEST_CASE_VARIABLE', title: 'Test Data Variable', description: 'Override a variable that will be used throughout this test case' },
  { icon: 'COMPARE_VARIABLE', title: 'Compare Variable', description: 'Compare 2 variables or a variable with text' },
]

export const PLAYBACK_INSERT_STEP_ACTIONS = [
  { icon: 'timeDelay', title: 'Delay', description: 'Add a delay (in ms) before or after the execution of a step' },
]

export type AutoDialogResponseMode = "default" | "all_positive" | "all_negative";

export const TIME_DELAY_DATA_TYPES = [
  {
    title: "5 seconds",
    value: "5",
  },
  {
    title: "10 seconds",
    value: "10",
  },
  {
    title: "20 seconds",
    value: "20",
  },
  {
    title: "30 seconds",
    value: "30",
  },
  {
    title: "40 seconds",
    value: "40",
  },
  {
    title: "50 seconds",
    value: "50",
  },
  {
    title: "60 seconds",
    value: "60",
  },
];
